import { render, staticRenderFns } from "./notification-item.vue?vue&type=template&id=165c1eee&scoped=true&"
import script from "./notification-item.vue?vue&type=script&lang=js&"
export * from "./notification-item.vue?vue&type=script&lang=js&"
import style0 from "./notification-item.vue?vue&type=style&index=0&id=165c1eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c1eee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
